import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { cartsData, currencyData, genUserId, wishsData } from "./constants";
import { getFromLocalStorage, saveToLocalStorage } from "./localStorageUtils";

export const printLogs = (obj, other) => {
    console.log(obj, other);
}

export const encodeMallToken = (payload) => {
    try {
        const jsonStr = JSON.stringify(payload);
        // Equivalent to PHP's base64_encode + urlencode
        const base64Str = btoa(jsonStr);
        return encodeURIComponent(base64Str);
    } catch (e) {
        console.error("Encoding failed", e);
        return null;
    }
};

export const decryptMallToken = (encodedToken) => {
    try {
        // React Router's useParams automatically decodes the URL component.
        // We revert any URL-safe modifications or space formatting just in case.
        let base64Token = encodedToken.replace(/-/g, '+').replace(/_/g, '/').replace(/ /g, '+');
        
        while (base64Token.length % 4) {
            base64Token += '=';
        }

        const decodedStr = atob(base64Token);
        const payload = JSON.parse(decodedStr);
        return typeof payload === 'object' ? payload : null;
    } catch (e) {
        console.error("Decoding failed", e);
        return null;
    }
};

export const generateUniqueId = () => {
    const timestamp = Date.now().toString(36); // Convert current timestamp to base-36
    const random = Math.random().toString(36).substring(2, 10); // Generate random string
    return `${timestamp}-${random}`;
};

export const shouldShowTokenPopup = () => {
    if (typeof window === 'undefined') return false;
    const hostname = window.location.hostname;
    return hostname.includes('localhost') || hostname.includes('web.infinytesystems.com');
};

export const getQueryParam = (location, name) => {
    const urlParams = new URLSearchParams(location.search);
    return urlParams.get(name);
}

export const saveItemObjInCart = (addProductObj) => {

    let carts = getFromLocalStorage(cartsData);
    if (carts != null) {

        let existingItem = carts.find((cartItem) => cartItem.selected_variant.id === addProductObj.selected_variant.id);
        if (existingItem) {
            existingItem.quantity += addProductObj.quantity;
        } else {
            carts.push(addProductObj);
        }
        saveToLocalStorage(cartsData, carts);
    }
    else {
        saveToLocalStorage(cartsData, [addProductObj]);
        carts = getFromLocalStorage(cartsData);
    }

    printLogs('', { carts, addProductObj });

    return { cartCount: carts?.length ?? 0, cart: carts != null ? carts : [addProductObj] }

}

export const saveItemObjInWishList = (addProductObj) => {
    let wishs = getFromLocalStorage(wishsData);
    if (wishs != null) {
        let existingItem = wishs.find((wishItem) => wishItem.selected_variant.id === addProductObj.selected_variant.id);
        if (existingItem) {
            existingItem.quantity += addProductObj.quantity;
        } else {
            wishs.push(addProductObj);
        }
        saveToLocalStorage(wishsData, wishs);
    }
    else {
        saveToLocalStorage(wishsData, [addProductObj]);
    }

    printLogs('wishs', { wishs, addProductObj });

    return { wishCount: wishs?.length ?? 0, wish: wishs != null ? wishs : [addProductObj] }
}

export const loadingView = () => {
    return (
        <div className="centerScreen">
            <div className="loader">

            </div>
        </div>
    );
}
export const errorView = (error) => {
    return (
        <div className="centerScreen">
            <p className="errorText">{error}</p>
        </div>
    );
}

// export const getConvertedPrice = (price) => {
//     let convertedPrice = 0;
//     const currency = getFromLocalStorage(currencyData);
//     if (currency) {
//         if (currency?.is_default == 1) {
//             convertedPrice = price;
//         }
//         else {
//             convertedPrice = price * currency.currency.exchange_rate
//         }
//     }

//     return parseFloat(convertedPrice?.toFixed(2));

// }

export const getConvertedPrice = (price) => {
    const currency = getFromLocalStorage(currencyData);

    if (!currency) return price;

    const rate = parseFloat(currency?.currency?.exchange_rate || 1);

    const convertedPrice = currency?.is_default === 1
        ? price
        : price * rate;

    return Number(convertedPrice.toFixed(2));
};

export const getBasePrice = (price) => {
    const currency = getFromLocalStorage(currencyData);

    if (!currency) return price;

    const rate = parseFloat(currency?.currency?.exchange_rate || 1);

    return currency?.is_default === 1
        ? price
        : price / rate;
};



export const formatOptionLabel = ({ value, label, iso2, phone_code }) => (
    <div style={{ display: 'flex', alignItems: 'center' }}>
        <img
            src={`https://flagcdn.com/w20/${iso2?.toLowerCase()}.png`}
            style={{ width: 20, height: 15, marginRight: 10 }}
            alt={label}
        />
        <span>{label} ({phone_code})</span>
    </div>
);

export const getPaymentObject = (merchantSettings, random_id) => {
    if (!merchantSettings?.merchant_integrations) return null;

    const paymentIntegration = merchantSettings.merchant_integrations.find(
        integration => integration.random_id === random_id
    );

    if (!paymentIntegration) return null;

    return {
        payment_id: paymentIntegration.integration_method_id,
        instance_id: paymentIntegration.instance_id,
        key: paymentIntegration.key,
        display_name: paymentIntegration.display_name
    };
};

export const initiateForeePay = (data, saveToLocalStorage, responseKey, executeForeePay, callback) => {
    saveToLocalStorage(responseKey, data);
    const transactionDetails = {
        'key': data.api_key,
        'amount': data.total_amount,
        'is_generated': 0,
        'reference_number': data.order_ref,
        'callback': callback,
        'customer_email_address': data.email,
        'customer_phone_number': data.phone,
        'consumer_name': data.name,
    }
    executeForeePay(transactionDetails);
};

export const handleForeeCallback = (responseJsonObject, getFromLocalStorage, removeFromLocalStorage, responseKey, callGetWebservice, onSuccess) => {
    let resp = getFromLocalStorage(responseKey);

    if (!responseJsonObject) {
        responseJsonObject = { order_ref: resp.order_ref };
    } else {
        responseJsonObject.order_ref = resp?.order_ref;
    }

    responseJsonObject.system = true;
    removeFromLocalStorage(responseKey);

    callGetWebservice('gateway/foreepay', responseJsonObject, (response) => {
        onSuccess(response, responseJsonObject);
    });
};

export const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
};

export const formatTime = (timeString) => {
    if (!timeString) return "";
    const [hours, minutes] = timeString.split(':');
    let h = parseInt(hours);
    const ampm = h >= 12 ? 'pm' : 'am';
    h = h % 12;
    h = h ? h : 12;
    const hh = String(h).padStart(2, '0');
    return `${hh}:${minutes} ${ampm}`;
};

export const validatePhone = (phone, country) => {
    if (!phone || !country) return false;
    try {
        const parsedPhone = parsePhoneNumberFromString(phone, country);
        return parsedPhone?.isValid() ?? false;
    } catch (e) {
        return false;
    }
};

export const getParsedPhone = (phone, country) => {
    if (!phone || !country) return null;
    try {
        return parsePhoneNumberFromString(phone, country);
    } catch (e) {
        return null;
    }
};

export const getNationalPhoneNumber = (phone, phoneCode, iso2) => {
    if (!phone) return "";
    
    try {
        const parsed = parsePhoneNumberFromString(phone, iso2);
        if (parsed && parsed.nationalNumber) {
            return parsed.nationalNumber;
        }
    } catch (e) {
        // fallback to manual stripping
    }

    let cleanPhone = phone.toString().trim();
    const code = phoneCode?.toString().replace('+', '') || '';
    
    if (code) {
        cleanPhone = cleanPhone.startsWith('+') ? cleanPhone.substring(1) : cleanPhone;
        if (cleanPhone.startsWith(code)) {
            cleanPhone = cleanPhone.substring(code.length);
        }
    }
    
    return cleanPhone;
};